import { render } from "./kehu.vue?vue&type=template&id=401a2825&scoped=true"
import script from "./kehu.vue?vue&type=script&lang=js"
export * from "./kehu.vue?vue&type=script&lang=js"

import "./kehu.vue?vue&type=style&index=0&id=401a2825&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401a2825"]])

export default __exports__